import dayjs from 'dayjs'

const PERIOD_DISPLAY_FORMAT = 'YYYY/MM/DD'

/**
 * 宿泊税の適用期間を一覧表示用の文字列にする
 * 開始・終了の片方だけ設定されることがあるため、未設定側は空けて「〜」だけを残す
 * 編集モーダルは日付クリア時に空文字を送信するため、空文字も null と同様に未設定として扱う
 *
 * @returns 両方未設定の場合は null
 */
export const formatTaxApplicablePeriod = (validFrom: string | null, validTo: string | null): string | null => {
  if (!validFrom && !validTo) {
    return null
  }
  const from = validFrom ? dayjs(validFrom).format(PERIOD_DISPLAY_FORMAT) : ''
  const to = validTo ? dayjs(validTo).format(PERIOD_DISPLAY_FORMAT) : ''
  return [from, '〜', to].filter(Boolean).join(' ')
}
